import React from "react";
import ReactDOM from "react-dom";
import {applyMiddleware, compose, createStore} from "redux";
import reduxThunk from "redux-thunk";
import reducers from "./reducers";
import Routes from "./routes/routes";
import {persistReducer, persistStore} from "redux-persist";
import {deviceStorage} from "./state/deviceStorage";
import deviceStorageControllerReducer from "./reducers/deviceStorageControllerReducer";
import {TESTING_MODE} from "./config/env";
import LogRocket from "logrocket";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const logRocketMiddleware = LogRocket.reduxMiddleware({
    stateSanitizer: function (state) {
        if (state.userDetails && state.userDetails.userToken) {
            return {
                ...state,
                userDetails: {
                    ...state.userDetails,
                    userToken: undefined,
                },
            };
        }
        return state;
    },
});

const persistConfig = {
    key: 'root',
    version: 1,
    storage: deviceStorage,
    blacklist: [deviceStorageControllerReducer],
    manualPersist: true
}

const loadStateReducer = (state, action) => {
    if(action.type === 'hydrate') {
        const restoredState = reducers(action.payload, action);

        // Preserved version number on hydrate
        if (action.currentAppFlags) {
            return {
                ...restoredState,
                appFlags: {
                    ...restoredState.appFlags,
                    appVersion: action.currentAppFlags.appVersion,
                    webVersion: action.currentAppFlags.webVersion,
                    reduxStateVersion: action.currentAppFlags.reduxStateVersion,
                    versionMismatch: action.currentAppFlags.versionMismatch
                }
            };
        }
        
        return restoredState;
    }
    return reducers(state, action);
}

const persistedReducer = persistReducer(persistConfig, loadStateReducer);

const store = createStore(
    persistedReducer,
  {},
  composeEnhancers(applyMiddleware(reduxThunk, logRocketMiddleware))
);

export const persistor = persistStore(store);

// Expose store to window for testing purposes
if (TESTING_MODE) {
    window.store = store;
}

ReactDOM.render(<Routes store={store} />, document.querySelector("#root"));
